import React, { useState } from "react";
import { Pencil, Check, X } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";

export const fmtKg = (v) => v == null ? null : `${Number(v).toLocaleString("it-IT", { minimumFractionDigits: 2, maximumFractionDigits: 4 })} €/kg`;
export const fmtDate = (iso) => iso ? new Date(iso).toLocaleDateString("it-IT") : null;

/** Prezzo €/kg con modifica in linea: Salva / Annulla, virgola decimale accettata (il server convalida e registra lo storico). */
export function MaterialPriceCell({ value, onSave, canEdit, testId, updatedAt, updatedBy }) {
  const [editing, setEditing] = useState(false);
  const [text, setText] = useState("");
  const [busy, setBusy] = useState(false);
  const start = () => { setText(value == null ? "" : String(value).replace(".", ",")); setEditing(true); };
  const save = async () => {
    if (!text.trim()) return;
    setBusy(true);
    try { await onSave(text.trim()); setEditing(false); } catch (_) { /* toast already shown by parent; keep editor open */ } finally { setBusy(false); }
  };
  if (editing) {
    return (
      <div className="flex items-center gap-1" data-testid={`${testId}-editor`}>
        <Input autoFocus inputMode="decimal" className="h-7 w-24 text-xs font-mono" data-testid={`${testId}-input`} value={text} placeholder="es. 4,50"
          onChange={(e) => setText(e.target.value)} onKeyDown={(e) => { if (e.key === "Enter") save(); if (e.key === "Escape") setEditing(false); }} />
        <span className="text-[10px] text-muted-foreground">€/kg</span>
        <Button size="sm" className="h-7 px-2" disabled={busy || !text.trim()} onClick={save} data-testid={`${testId}-save`}><Check size={12} className="mr-1" />Salva</Button>
        <Button size="sm" variant="outline" className="h-7 px-2" disabled={busy} onClick={() => setEditing(false)} data-testid={`${testId}-cancel`}><X size={12} className="mr-1" />Annulla</Button>
      </div>
    );
  }
  return (
    <div className="flex items-center gap-2" data-testid={testId} data-missing={value == null ? "true" : "false"}>
      {value == null
        ? <span className="px-1.5 py-0.5 text-[10px] font-medium bg-amber-50 text-amber-900 border border-amber-200" data-testid={`${testId}-missing`}>Da completare</span>
        : <span className="font-mono text-xs" data-testid={`${testId}-value`}>{fmtKg(value)}</span>}
      {canEdit && <button type="button" title="Modifica prezzo" aria-label="Modifica prezzo €/kg" onClick={start} data-testid={`${testId}-edit`} className="p-1 hover:bg-muted border border-border"><Pencil size={11} /></button>}
      {(updatedAt || updatedBy) && <span className="text-[10px] text-muted-foreground" data-testid={`${testId}-updated`}>agg. {fmtDate(updatedAt) || "—"}{updatedBy ? ` · ${updatedBy}` : ""}</span>}
    </div>
  );
}
